import { Component, OnInit } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { SetLanguagePage } from './set-language/set-language.page';
import { SetCachePage } from './set-cache/set-cache.page';
import { SetProfilePage } from './set-profile/set-profile.page';
import { ShowTermsPage } from './show-terms/show-terms.page';
import { VocabularyService } from '../../services/vocabulary/vocabulary.service';

@Component({
  selector: 'app-settings',
  templateUrl: 'settings.page.html',
  styleUrls: ['settings.page.scss']
})
export class SettingsPage implements OnInit {
  constructor(public modalController: ModalController,public vS:VocabularyService) {

  }

  ngOnInit() {

  }

  async setLanguage() {
    const modal = await this.modalController.create({
        component: SetLanguagePage
    }).then();
    return await modal.present();
  }

  async setCache() {
    const modal = await this.modalController.create({
        component: SetCachePage
    }).then();
    return await modal.present();
  }


  async setProfile() {
    const modal = await this.modalController.create({
        component: SetProfilePage
    }).then();
    return await modal.present();
  }

  async showTerms() {
    const modal = await this.modalController.create({
        component: ShowTermsPage
    })
    return await modal.present();
  }


}
